<div class="flex flex-col gap-4 pt-2 pb-4">
  <span class="text-sm text-gray-500">
    Verbinde planBIC mit den Cloud-Speichern deiner Organisation. Ordner aus einer verbundenen Quelle kannst du
    anschließend in den zugeordneten Projekten unter „Dateien“ verknüpfen – neue und geänderte Dateien werden
    automatisch übernommen und können geprüft werden.
  </span>

  <!-- SharePoint -->
  <div class="flex flex-col gap-4 p-4 rounded-lg border border-gray-200 bg-white">
    <div class="flex flex-row items-center gap-3">
      <img src="assets/connectors/sharepoint.svg" alt="" class="w-10 h-10 shrink-0">
      <div class="flex flex-col flex-grow min-w-0">
        <span class="text-sm font-semibold text-gray-900">Microsoft SharePoint</span>
        <span class="text-sm text-gray-500">Dokumentbibliotheken aus Microsoft 365</span>
      </div>

      @if (!loading && !loadError) {
        @switch (status) {
          @case ('ACTIVE') {
            <bic-badge type="success">Verbunden</bic-badge>
            <bic-button buttonType="white" [disabled]="busy" (onClick)="disconnect()">
              <fa-icon [icon]="faLinkSlash" class="pr-2"></fa-icon>Verbindung trennen
            </bic-button>
          }
          @case ('PENDING_CONSENT') {
            <bic-badge type="warning">Zustimmung ausstehend</bic-badge>
            <bic-button buttonType="white" [disabled]="busy" (onClick)="disconnect()">Abbrechen</bic-button>
            <bic-button [disabled]="busy" (onClick)="connect()">Zustimmungslink</bic-button>
          }
          @case ('ERROR') {
            <bic-badge type="error">Fehler</bic-badge>
            <bic-button [disabled]="busy" (onClick)="connect()">Erneut verbinden</bic-button>
          }
          @default {
            <bic-button [disabled]="busy" (onClick)="connect()">Verbinden</bic-button>
          }
        }
      }
    </div>

    @if (loading) {
      <span class="text-sm text-gray-500">Wird geladen …</span>
    } @else if (loadError) {
      <span class="text-sm text-red-600">Die Datenquellen konnten nicht geladen werden.</span>
    } @else {
      @if (status === 'ERROR' && sharePoint?.errorMessage) {
        <span class="text-sm text-red-600">{{ sharePoint?.errorMessage }}</span>
      }
      @if (status === 'PENDING_CONSENT') {
        <span class="text-sm text-gray-500">
          Ein Administrator von Microsoft 365 muss der App „planBIC Connector“ zustimmen. Den Link kannst du selbst
          öffnen oder an eure IT senden.
        </span>
      }

      @if (isActive && sharePoint) {
        <div class="flex flex-row flex-wrap gap-x-12 gap-y-3">
          <div class="flex flex-col">
            <span class="text-xs text-gray-500">Microsoft-Tenant</span>
            <span class="text-sm text-gray-900">{{ sharePoint.tenantDomain || sharePoint.tenantId }}</span>
          </div>
          @if (sharePoint.connectedAt) {
            <div class="flex flex-col">
              <span class="text-xs text-gray-500">Verbunden am</span>
              <span class="text-sm text-gray-900">{{ sharePoint.connectedAt | date:'dd.MM.yyyy' }}</span>
            </div>
          }
        </div>

        <div class="border-t border-gray-200"></div>

        <div class="flex flex-row items-start gap-3">
          <div class="flex flex-col flex-grow">
            <span class="text-sm font-semibold text-gray-900">Freigegebene Sites</span>
            <span class="text-sm text-gray-500">
              planBIC kann nur auf diese SharePoint-Sites zugreifen. Ordner verknüpfen können Nutzer nur in Projekten,
              denen die Site zugeordnet ist. Freigeben und Entfernen erledigt ein SharePoint-Admin.
            </span>
          </div>
          <bic-button buttonType="white" [disabled]="busy" (onClick)="manageSites()">
            <fa-icon [icon]="faPlus" class="pr-2"></fa-icon>Sites verwalten
          </bic-button>
        </div>

        @if (sharePoint.sites?.length) {
          <div class="flex flex-col rounded-lg border border-gray-200 divide-y divide-gray-200">
            @for (site of sharePoint.sites; track site.id) {
              <div class="flex flex-row items-center gap-3 px-4 py-3">
                <fa-icon [icon]="faBuilding" class="text-gray-700"></fa-icon>
                <div class="flex flex-col flex-grow min-w-0">
                  <span class="text-sm text-gray-900 truncate">{{ site.displayName }}</span>
                  <span class="text-xs text-gray-500 truncate">{{ site.webUrl }}</span>
                </div>
                <span class="text-sm text-gray-500 whitespace-nowrap" [title]="projectNames(site)">{{ projectSummary(site) }}</span>
                <bic-button buttonType="white" (onClick)="assignProjects(site)">Projekte zuordnen</bic-button>
                <bic-badge type="success">Lesezugriff</bic-badge>
              </div>
            }
          </div>
        } @else {
          <span class="text-sm text-gray-500">Noch keine Site freigegeben.</span>
        }
      }
    }
  </div>

  <!-- Autodesk (folgt, BIC-Frontend#2722) -->
  <div class="flex flex-row items-center gap-3 p-4 rounded-lg border border-gray-200 bg-white">
    <img src="assets/connectors/autodesk.svg" alt="" class="w-10 h-10 p-1.5 shrink-0">
    <div class="flex flex-col flex-grow">
      <span class="text-sm font-semibold text-gray-900">Autodesk Forma (ehem. ACC)</span>
      <span class="text-sm text-gray-500">Projekte und Ordner aus Autodesk Construction Cloud</span>
    </div>
    <bic-badge bgClass="bg-gray-100" textClass="text-gray-600">Demnächst</bic-badge>
    <bic-button buttonType="white" [disabled]="true">Verbinden</bic-button>
  </div>
</div>
